import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';

import CaregiverView from './CaregiverView';

// The read-only copy of the client Caregivers tab. It lists Loom's caregiver assignments and has no
// add-caregiver dialog or status changes.
const CaregiverConnection = (props) => {
  const clientData = props.clientData;

  const caregivers = clientData.caregivers || {};

  return (
    <Stack>
      {
        Object.entries(caregivers).map(([assignmentId, caregiver]) => (
          <CaregiverView
            key={assignmentId}
            caregiver={caregiver}
          />
        ))
      }
    </Stack>
  );
};

CaregiverConnection.propTypes = {
  clientData: PropTypes.object.isRequired,
};
export default React.memo(CaregiverConnection);
